import VueI18n from 'vue-i18n'   //引入vue-i18n
import Vue from 'vue'

const getQueryVariable = function (variable){
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] === variable){return pair[1];}
      }
      return(false);
}

Vue.use(VueI18n)
// let locale;
// localStorage.getItem('locale') ? locale = localStorage.getItem('locale') : locale = 'zh';
// localStorage.setItem('locale',locale);

let locale = 'zh';
localStorage.setItem('locale','zh');

// if(getQueryVariable('type')==='en'||getQueryVariable('type')==='ennews'){
// 	locale = 'en';
// 	localStorage.setItem('locale',locale);
// }

const i18n = new VueI18n({
  locale: locale,    // 语言标识
  messages: {
    'zh': require('./lang/cn'),   // 中文语言包
    'en': require('./lang/en'),   // 英文语言包
  },
})
 
export default  i18n